module.exports = __webpack_public_path__ + "static/media/ELLE.4050ddc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ELLE.svg
// module id = 623
// module chunks = 0